import { render, staticRenderFns } from "./ErrorAddRecord.vue?vue&type=template&id=2cf4bb6c&scoped=true"
import script from "./ErrorAddRecord.vue?vue&type=script&lang=js"
export * from "./ErrorAddRecord.vue?vue&type=script&lang=js"
import style0 from "./ErrorAddRecord.vue?vue&type=style&index=0&id=2cf4bb6c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cf4bb6c",
  null
  
)

export default component.exports